export enum SubscriptionTier {
  FREE_TRIAL = 'free_trial',
  PREMIUM_MONTHLY = 'monthly',
  PREMIUM_ANNUAL = 'annual'
}

export enum SubscriptionStatus {
  TRIAL_ACTIVE = 'trial_active',
  ACTIVE = 'active',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  TRIAL_EXPIRED = 'trial_expired',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  UNPAID = 'unpaid',
  LEGACY_GRACE_PERIOD = 'legacy_grace_period'
}

export interface SubscriptionPlan {
  tier: SubscriptionTier;
  displayName: string;
  price: number;
  billingPeriod: 'trial' | 'month' | 'year';
  accessDuration: number;
  description: string;
}
